import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomumbaiurbaniaonrent() {



  const cardData =
  {
    keyword: 'Pune to Mumbai Urbania On Rent',
    heading: 'Amruta Travels: Pune to Mumbai Urbania On Rent',
    headingDescription: 'Amruta Travels Pvt. Ltd. offers Pune to Mumbai Urbania on Rent, providing a luxurious, safe, and convenient travel experience for business trips, family journeys, and airport transfers. Our premium Force Urbania vans feature reclining seats, spacious interiors, advanced air conditioning, and smooth suspension, ensuring a relaxing ride throughout the Pune–Mumbai route. Whether you’re traveling to Mumbai Airport, BKC, Andheri, or Navi Mumbai, our professional chauffeurs guarantee punctual pickups and a smooth, comfortable journey. With options for 10-seater, 13-seater, and 17-seater Urbania vans, Amruta Travels’ Pune to Mumbai Urbania Rental is the preferred choice for travelers seeking a perfect mix of elegance, comfort, and reliability on every trip.',

    top: 'Top Places to Visit in Mumbai with Amruta Travels',

"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India is Mumbai’s most famous landmark, built in 1924 to commemorate the visit of King George V and Queen Mary. Overlooking the Arabian Sea, its Indo-Saracenic architecture makes it a stunning waterfront attraction. Tourists gather here to enjoy ferry rides, photography, and sunset views. The Gateway stands as the symbolic entrance to Mumbai’s colonial and cultural history."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, also known as the Queen’s Necklace, is a 3.6 km-long boulevard curving gracefully along the Arabian Sea. The glittering streetlights at night resemble a string of pearls, offering one of Mumbai’s most romantic sights. Locals and tourists enjoy evening strolls and sea breezes here. Marine Drive is Mumbai’s signature promenade of beauty and relaxation."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
    "description": "Chhatrapati Shivaji Maharaj Terminus, a UNESCO World Heritage Site, is an architectural masterpiece of Victorian Gothic design. Built in 1887, this grand railway station combines Indian and British influences with intricate carvings and stained glass windows. It’s one of India’s busiest rail hubs and a historic icon. CSMT is Mumbai’s majestic symbol of colonial grandeur and urban energy."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Siddhivinayak Temple in Prabhadevi is dedicated to Lord Ganesha and attracts millions of devotees every year. The gold-plated idol and serene ambience create a divine experience for worshippers. Celebrities and locals alike visit to seek blessings before new ventures. The temple represents Mumbai’s deep spiritual roots amidst its fast-paced modern life."
  },
  {
    "title": "Elephanta Caves",
    "description": "Located on Elephanta Island, these ancient rock-cut caves date back to the 5th–7th centuries and are dedicated to Lord Shiva. The main attraction is the magnificent three-headed Trimurti sculpture representing Shiva’s divine forms. Accessible by ferry from the Gateway of India, it’s a UNESCO World Heritage Site. Elephanta Caves are Mumbai’s timeless connection to India’s artistic and religious heritage."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is Mumbai’s most popular seaside hangout, known for its golden sands, street food stalls, and lively atmosphere. Visitors enjoy bhel puri, pav bhaji, and local ice creams while watching the sunset. It’s also a favorite jogging and filming location for Bollywood stars. Juhu Beach captures Mumbai’s blend of leisure, cinema, and culture."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah stands gracefully on a small islet off Worli Coast, connected to the city by a narrow walkway. Built in 1431, this Indo-Islamic shrine is dedicated to Saint Pir Haji Ali Shah Bukhari. The white domes against the sea create a breathtaking view during high tide. Haji Ali is Mumbai’s symbol of faith, unity, and peace."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Vastu Sangrahalaya (Prince of Wales Museum)",
    "description": "This magnificent museum showcases India’s ancient history, sculptures, and art collections. Built in the early 1900s with Indo-Saracenic architecture, it houses artifacts from the Mughal, Maratha, and British eras. Its lush gardens and domed structure enhance its charm. It’s Mumbai’s finest cultural and educational destination for art and history lovers."
  },
  {
    "title": "Colaba Causeway",
    "description": "Colaba Causeway is a vibrant shopping street famous for its mix of street stalls and upscale boutiques. From antique jewelry and handicrafts to trendy apparel and cafés, it’s a paradise for tourists. The energy of the market perfectly reflects Mumbai’s cosmopolitan vibe. Colaba Causeway is the city’s lively blend of commerce, culture, and creativity."
  },
  {
    "title": "Sanjay Gandhi National Park & Kanheri Caves",
    "description": "Sanjay Gandhi National Park is a green oasis in the heart of Mumbai, home to leopards, deer, and exotic birds. Within the park lie the ancient Kanheri Caves, Buddhist rock-cut structures dating back over 2,000 years. Visitors enjoy cycling, boating, and nature trails here. It’s Mumbai’s refreshing retreat blending history, wildlife, and tranquility."
  }
],



    "services": [
    {
      "name": "Pune to Mumbai Urbania On Rent",
      "description": "Rent a comfortable and spacious Urbania van for your journey from Pune to Mumbai. Perfect for group travel, family trips, and corporate commutes, ensuring a smooth and safe ride."
    },
    {
      "name": "Urbania Hire Pune to Mumbai",
      "description": "Flexible Urbania hire services from Pune to Mumbai tailored to your travel needs with reliable vehicles and professional drivers."
    },
    {
      "name": "Force Urbania Pune to Mumbai",
      "description": "Powerful and spacious Force Urbania vans for comfortable travel between Pune and Mumbai, offering ample seating and luggage space."
    },
    {
      "name": "AC Urbania Pune to Mumbai",
      "description": "Air-conditioned Urbania vans providing a cool and comfortable travel experience from Pune to Mumbai, perfect for long-distance trips."
    },
    {
      "name": "Non AC Urbania Pune to Mumbai",
      "description": "Affordable and practical non-AC Urbania vans for Pune to Mumbai travel, suitable for budget travelers without compromising space or comfort."
    },
    {
      "name": "Luxury Urbania Pune to Mumbai",
      "description": "Travel in style with luxury Urbania vans equipped with premium interiors and amenities for a premium experience on Pune to Mumbai route."
    },
    {
      "name": "17 Seater Urbania Pune to Mumbai",
      "description": "Spacious 17-seater Urbania vans ideal for group travel from Pune to Mumbai, offering comfort and safety for all passengers."
    },
    {
      "name": "16 Seater Urbania Pune to Mumbai",
      "description": "Reliable 16-seater Urbania vans for medium-sized groups traveling between Pune and Mumbai, ensuring efficient and comfortable transportation."
    },
    {
      "name": "Pune to Mumbai Airport Urbania",
      "description": "Specialized Urbania van services from Pune to Mumbai airport, ensuring timely and hassle-free airport transfers with ample luggage space."
    },
    {
      "name": "Corporate Urbania Pune to Mumbai",
      "description": "Corporate Urbania hire for business trips and employee transfers between Pune and Mumbai, with professional service and punctuality."
    },
    {
      "name": "Pune to Mumbai Outstation Urbania",
      "description": "Outstation Urbania van rental service for convenient travel between Pune and Mumbai for both personal and corporate needs."
    },
    {
      "name": "Urbania Booking Pune to Mumbai",
      "description": "Easy and quick online booking for Urbania vans traveling from Pune to Mumbai, offering competitive pricing and flexible schedules."
    },
    {
      "name": "Affordable Urbania Pune Mumbai",
      "description": "Budget-friendly Urbania van rental options for Pune to Mumbai travel, providing value without compromising comfort or reliability."
    },
    {
      "name": "Urbania Hire near Me Pune",
      "description": "Find and hire Urbania vans near your location in Pune for convenient and hassle-free travel to Mumbai."
    },
    {
      "name": "Pune to Mumbai Express Urbania",
      "description": "Express Urbania van services from Pune to Mumbai, offering faster travel times and direct routes for urgent and timely trips."
    },
    {
      "name": "Force Urbania Rental Pune Mumbai",
      "description": "Reliable Force Urbania rental service for the Pune to Mumbai route, combining power, space, and comfort for your journey."
    },
    {
      "name": "Tourist Urbania Pune Mumbai",
      "description": "Tourist-friendly Urbania vans designed for sightseeing and leisure travel from Pune to Mumbai with spacious interiors and safety features."
    },
    {
      "name": "Urbania Travel Pune to Mumbai",
      "description": "Comprehensive Urbania travel service between Pune and Mumbai offering comfortable seating, experienced drivers, and timely pickups."
    }
  ],
  "tableData": [
    ["Pune to Mumbai Urbania On Rent", "Urbania Hire Pune to Mumbai"],
    ["Force Urbania Pune to Mumbai", "AC Urbania Pune to Mumbai"],
    ["Non AC Urbania Pune to Mumbai", "Luxury Urbania Pune to Mumbai"],
    ["17 Seater Urbania Pune to Mumbai", "16 Seater Urbania Pune to Mumbai"],
    ["Pune to Mumbai Airport Urbania", "Corporate Urbania Pune to Mumbai"],
    ["Pune to Mumbai Outstation Urbania", "Urbania Booking Pune to Mumbai"],
    ["Affordable Urbania Pune Mumbai", "Urbania Hire near Me Pune"],
    ["Pune to Mumbai Express Urbania", "Force Urbania Rental Pune Mumbai"],
    ["Tourist Urbania Pune Mumbai", "Urbania Travel Pune to Mumbai"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Pune to Mumbai Urbania On Rent",
    "WhyChoosedescription": "Amruta Travels Pvt Ltd provides comfortable and reliable Urbania rental services for Pune to Mumbai trips, ideal for group travel between these two cities."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable Seating",
    "WhyChoosedescription": "Our Urbania vans offer ample space and ergonomic seating to ensure a relaxing journey on the Pune to Mumbai route."
  },
  {
    "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
    "WhyChoosedescription": "We regularly service and sanitize our Urbania vans to guarantee safety, hygiene, and comfort during your trip."
  },
  {
    "WhyChooseheading": "Transparent and Competitive Pricing",
    "WhyChoosedescription": "Enjoy clear, upfront pricing with no hidden fees, offering excellent value for your Pune to Mumbai travel."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages",
    "WhyChoosedescription": "Choose rental durations and packages tailored for your Pune to Mumbai trip, including one-way or round trips."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our skilled drivers are familiar with the Pune to Mumbai route, ensuring a safe, punctual, and smooth journey."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available round-the-clock to assist with bookings, route planning, and travel assistance."
  },
  {
    "WhyChooseheading": "Easy and Quick Booking Process",
    "WhyChoosedescription": "Book your Pune to Mumbai Urbania rental online or via phone quickly, with prompt vehicle delivery and reliable service."
  }
]
























  }

const faqData = [
  {
    question: 'Does Amruta Travels Pvt Ltd offer Urbania on rent for Pune to Mumbai trips?',
    answer: 'Yes, Amruta Travels Pvt Ltd provides Urbania vehicles on rent for comfortable and safe travel from Pune to Mumbai.',
  },
  {
    question: 'How can I book an Urbania for Pune to Mumbai travel with Amruta Travels?',
    answer: 'You can easily book through our website, mobile app, or by contacting our 24×7 customer support team.',
  },
  {
    question: 'What amenities are available in the Urbania vehicles for Pune to Mumbai trips?',
    answer: 'Our Urbania vehicles come with comfortable seating, air conditioning, and essential safety features for a pleasant journey.',
  },
  {
    question: 'Are the drivers experienced in Pune to Mumbai routes for Urbania hires?',
    answer: 'Yes, our drivers are professional, experienced, and knowledgeable about the Pune to Mumbai route to ensure a safe and timely trip.',
  },
  {
    question: 'Can Urbania vehicles be hired for one-way or round trips between Pune and Mumbai?',
    answer: 'Absolutely. We offer flexible booking options for both one-way and round trips between Pune and Mumbai.',
  },
  {
    question: 'Is the Urbania rental service for Pune to Mumbai available 24×7?',
    answer: 'Yes, Amruta Travels offers 24×7 availability for Pune to Mumbai Urbania rentals to suit your travel plans.',
  },
  {
    question: 'What safety and hygiene measures are followed for Pune to Mumbai Urbania hires?',
    answer: 'All vehicles are sanitized thoroughly before each trip, and drivers follow strict hygiene and safety protocols.',
  },
  {
    question: 'What payment options are accepted for Pune to Mumbai Urbania rentals?',
    answer: 'We accept payments via UPI, credit/debit cards, digital wallets, and bank transfers for your convenience.',
  },
  {
    question: 'Is customer support available throughout the Pune to Mumbai Urbania rental period?',
    answer: 'Yes, our 24×7 customer support team is available to assist you anytime during your Pune to Mumbai Urbania rental.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Anil Patil',
    feedback: 'The Pune to Mumbai Urbania from Amruta Travels was comfortable and the driver was punctual and professional.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Sneha Kulkarni',
    feedback: 'Excellent service for Pune to Mumbai Urbania hire. Highly recommend Amruta Travels for safe and comfortable travel.',
    rating: 5,
  },
];










































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "24 Seater Bus for Rent in Pune", link: "24-seater-bus-for-rent-in-pune" },
  { place: "/images/keyword/2.jpg", text: "16 Seater Urbania for Rent in Pune", link: "16-seater-urbania-for-rent-in-pune" },
  { place: "/images/keyword/3.jpg", text: "14 Seater Urbania Hire in Pune", link: "14-seater-urbania-hire-in-pune" },
  { place: "/images/keyword/4.jpg", text: "17 Seater Urbania Hire in Pune", link: "17-seater-urbania-hire-in-pune" },
  { place: "/images/keyword/5.jpg", text: "Mini Bus On Rent in Pimpri Chinchwad", link: "mini-bus-on-rent-in-pimpri-chinchwad" },
  { place: "/images/keyword/6.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
  { place: "/images/keyword/7.jpg", text: "Force Urbania 17 Seater On Rent in Pune", link: "force-urbania-17-seater-on-rent-in-pune" },
  { place: "/images/keyword/8.jpg", text: "35 Seater Bus On Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/9.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/10.jpg", text: "53 Seater Bus On Rent in Pune", link: "53-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/11.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/12.jpg", text: "Bus On Rent in Pune", link: "bus-on-rent-in-pune" },
  { place: "/images/keyword/13.jpg", text: "Bus Hire in Pune", link: "bus-hire-in-pune" },
  { place: "/images/keyword/14.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
  { place: "/images/keyword/15.jpg", text: "Bus Rental for Corporate Events in Pune", link: "bus-rental-for-corporate-events-in-pune" },
  { place: "/images/keyword/16.jpg", text: "Wedding Bus Booking Online Pune", link: "wedding-bus-booking-online-pune" },
  { place: "/images/keyword/17.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
  { place: "/images/keyword/18.jpg", text: "Bus Hire for Party Events in Pune", link: "bus-hire-for-party-events-in-pune" },
  { place: "/images/keyword/19.jpg", text: "Full Bus Booking for Marriage Pune", link: "full-bus-booking-for-marriage-pune" },
  { place: "/images/keyword/20.jpg", text: "AC Luxury Bus On Rent in Pune", link: "ac-luxury-bus-on-rent-in-pune" },
  { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
  { place: "/images/keyword/22.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "luxury-force-urbania-on-rent-in-pune" },
  { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Pune for Corporate", link: "urbania-on-rent-in-pune-for-corporate" },
  { place: "/images/keyword/24.jpg", text: "Pune to Goa Urbania On Rent", link: "pune-to-goa-urbania-on-rent" },
  { place: "/images/keyword/25.jpg", text: "Pune to Mumbai Urbania on Rent", link: "pune-to-mumbai-urbania-on-rent" }
];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Urbania On Rent",
  "image": "https://www.amrutatravelspvtltd.com/images/keyword/25.jpg",
  "description": "Book Pune to Mumbai Urbania On Rent with Amruta Travels Pvt. Ltd. Offering AC, Non-AC, and Luxury Force Urbania vans for corporate travel, airport transfers, and tourist trips. Comfortable and affordable Pune to Mumbai Urbania rental service.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels Pvt. Ltd."
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.92",
    "ratingCount": "14720"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "7500",
    "availability": "https://schema.org/InStock",
    "url": "https://www.amrutatravelspvtltd.com/pune-to-mumbai-urbania-on-rent"
  }
};






  return (
    <div>

<Helmet>
  <title>Pune to Mumbai Urbania On Rent | Force Urbania Van Hire | Amruta Travels Pvt. Ltd.</title>
  <meta
    name="description"
    content="Book Pune to Mumbai Urbania On Rent with Amruta Travels Pvt. Ltd. Offering AC, Non-AC, and Luxury Force Urbania vans for corporate travel, airport transfers, and tourist trips. Reliable and affordable Pune to Mumbai Urbania rental service."
  />
  <meta
    name="keywords"
    content="Pune to Mumbai Urbania On Rent, Urbania Hire Pune to Mumbai, Force Urbania Pune to Mumbai, AC Urbania Pune to Mumbai, Non AC Urbania Pune to Mumbai, Luxury Urbania Pune to Mumbai, 17 Seater Urbania Pune to Mumbai, 16 Seater Urbania Pune to Mumbai, Pune to Mumbai Airport Urbania, Corporate Urbania Pune to Mumbai, Pune to Mumbai Outstation Urbania, Urbania Booking Pune to Mumbai, Affordable Urbania Pune Mumbai, Urbania Hire near Me Pune, Pune to Mumbai Express Urbania, Force Urbania Rental Pune Mumbai, Tourist Urbania Pune Mumbai, Urbania Travel Pune to Mumbai"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
<section className="page-header">
        <div
          className="page-header__bg"
          style={{
            backgroundImage: "url(/images/page-header-bg-1-1.jpg)",
          }}
        ></div>
        <div className="container">
          <div className="page-header__content">
            <h2 className="page-header__title">   {cardData.keyword}</h2>
          </div>
        </div>
      </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/25.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Amruta Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Amruta Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918010014995" className="pc-call">+91 8010014995</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918010014995"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918010014995" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@amrutatravelspvtltd.com" className="pc-email">
                      booking@amrutatravelspvtltd.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Amruta Travels Pvt Ltd</strong><br />
                      Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomumbaiurbaniaonrent;